export const story = {
  content: {
    cfHero: [
      {
        title: 'Car finance',
        body: {
          type: 'doc',
          content: [
            {
              type: 'paragraph',
              content: [
                {
                  text: 'Spread the cost of your car over 36 to 60 months, with flexible deposits and ',
                  type: 'text',
                  marks: [
                    {
                      type: 'textStyle',
                      attrs: { color: 'rgb(25, 29, 23)' },
                    },
                  ],
                },
                {
                  text: 'HP (Hire purchase)',
                  type: 'text',
                  marks: [
                    {
                      type: 'link',
                      attrs: {
                        href: '/car-finance/hire-purchase',
                        uuid: null,
                        anchor: null,
                        target: '_blank',
                        linktype: 'url',
                      },
                    },
                    {
                      type: 'textStyle',
                      attrs: { color: 'rgb(25, 29, 23)' },
                    },
                  ],
                },
                {
                  text: ' or ',
                  type: 'text',
                  marks: [
                    {
                      type: 'textStyle',
                      attrs: { color: 'rgb(25, 29, 23)' },
                    },
                  ],
                },
                {
                  text: 'PCP (Personal Contract Purchase)',
                  type: 'text',
                  marks: [
                    {
                      type: 'link',
                      attrs: {
                        href: '/car-finance/personal-contract-purchase',
                        uuid: null,
                        anchor: null,
                        target: '_blank',
                        linktype: 'url',
                      },
                    },
                    {
                      type: 'textStyle',
                      attrs: { color: 'rgb(25, 29, 23)' },
                    },
                  ],
                },
                {
                  text: ' plans ',
                  type: 'text',
                  marks: [
                    {
                      type: 'textStyle',
                      attrs: { color: 'rgb(25, 29, 23)' },
                    },
                  ],
                },
              ],
            },
          ],
        },
        image: {
          filename: '/images/car-finance-bmw-pound-sign.png',
          alt: 'Blue BMW car with pound sign floating above it',
        },
        component: 'CarFinanceHero',
      },
    ],
  },
}
